import React from 'react';

import ProspectsWidget from '@components/widget/ProspectsWidget';
import ProspectsMobileWidget from '@components/widget/ProspectsMobileWidget';
import TrainingWidget from '@components/widget/TrainingWidget';
import Panel from '@components/smartAdminUI/Panel';

const Prospects = () => (
  <>
    <div className="subheader">
      <h1 className="subheader-title">
        <i className="subheader-icon fal fa-address-card mr-2" />
        Prospects
        <small>
          Powered by CoreLogic
        </small>
      </h1>
    </div>
    <div className="row">
      <div className="col-lg-12">
        <Panel>
          <h4>
            Members! Did you know that as part of your Pillar 9™ fees you have access to the&nbsp;
            <strong>Premium Level Pro version</strong>
            &nbsp;of all of Prospects tools?
          </h4>
          <p>
            Prospects CRM provides you with all the tools you need to succeed and
            thrive in a highly competitive market. Manage your contacts and your
            everyday business better than ever with this powerful CRM that&apos;s
            designed for real estate professionals.&nbsp;
          </p>
          <p>
            Learn more about Prospects here:&nbsp;
            <a
              href="https://sales.prospects.com/crm/"
              target="_blank"
              rel="noreferrer"
            >
              Prospects CRM. Build Stronger Relationships, Accelerate your
              Business
            </a>
          </p>
        </Panel>
        <Panel>
          <h4>Access & Login</h4>
          <p>
            To log into Prospects, visit&nbsp;
            <a
              href="https://sales.prospects.com/crm/"
              target="_blank"
              rel="noreferrer"
            >
              Prospects.com
            </a>
            &nbsp;
            and click the red login button in the top right corner. Then, enter your public ID, authenticator password, and your 4 digit pin number (the same way you log into Matrix™).
          </p>
        </Panel>
      </div>
    </div>
    <div className="row">
      <div className="col-lg-4 d-flex">
        <Panel customClass="w-100">
          <ProspectsWidget />
        </Panel>
      </div>
      <div className="col-lg-4 d-flex">
        <Panel customClass="w-100">
          <ProspectsMobileWidget />
        </Panel>
      </div>
      <div className="col-lg-4 d-flex">
        <Panel customClass="w-100">
          <TrainingWidget url="https://pillarnine.com/prospects-crm" />
        </Panel>
      </div>
    </div>
  </>
);

export default Prospects;
